<template>
  <v-layout row wrap>
    <v-flex xs11 sm5>
      <v-dialog
        ref="dialog"
        persistent
        v-model="modal"
        lazy
        full-width
        width="290px"
        :return-value.sync="date"
      >
        <v-btn slot="activator" flat><v-icon>date_range</v-icon></v-btn>
        <v-date-picker v-model="date" 
            :min="minDate"
            :max="maxDate"
            locale="nl"
            scrollable>
          <v-spacer></v-spacer>
          <v-btn flat color="primary" @click="modal = false">Annuleren</v-btn>
          <v-btn flat color="primary" @click="$refs.dialog.save(date)">OK</v-btn>
        </v-date-picker>
      </v-dialog>
    </v-flex>
  </v-layout>
</template>

<script>
  export default {
    name: 'PlannerFilter',  
    data: () => ({
      date: null,
      menu: false,
      modal: false,
      min: '2016-06-15',
      max: '2018-03-20',
    }),
    props: ['minDate','maxDate'],
    watch: {
        date(newVal) {
            this.$emit('gotoDate', newVal);
        }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/Planner/PlannerFilter.vue